import { Lookup } from './lookup.interface';
export interface SignerTypesLookup extends Lookup {
  code: string; //force code to be a required attribute
  requiresAccountVerified?: boolean; //configurable option to require signers to be using a verified account
}

// 1. Define the allowed keys
export type SignerType = 'spousePartner' | 'financialAdministrator';
export const SignerTypes: Record<SignerType, SignerTypesLookup> = {
  spousePartner: { code: 'spousePartner', displayValue: 'Spouse/Partner', requiresAccountVerified: false },
  financialAdministrator: {
    code: 'financialAdministrator',
    displayValue: 'Financial Administrator',
    requiresAccountVerified: false,
  },
};
